export default __webpack_public_path__ + "static/media/a036-2.f1de7a7a.svg";